import {colors} from "@c10h/colors";
import Link from "next/link";
import {useTranslation} from "ni18n";
import React, {useEffect, useState} from "react";
import {Controller, Scene} from "react-scrollmagic";

import {dev, v5Pages} from "../../_common/_constants";
import styles from "./Header.module.scss";

export const Hdr = () => (
  <Link href={{pathname: v5Pages.home}} className={styles.l}>
    <span className={`${styles.l2} cIcon-guard`} />
    <span className={styles.l3}>COVID</span>
    <span className={styles.l4}>Ready</span>
    <span className={styles.l5}>by Carbon Health</span>
  </Link>
);

const Inner = () => {
  const i18n = useTranslation();
  const items = [
    {
      id: 1,
      title: i18n.t("Baseline Testing"),
      link: "#how",
      dotColor: colors.yellow,
    },
    {
      id: 2,
      title: i18n.t("Monitoring & Reporting"),
      link: "#monitoring",
      dotColor: colors.mint,
    },
    {
      id: 3,
      title: i18n.t("About Carbon Health"),
      link: "#about",
      dotColor: colors.purple,
    },
  ];
  const [id, setId] = useState(null);
  return (
    <div className={styles.wrap}>
      <Hdr />
      <div className={`basic ${id ? "hoveredParent" : ""} ${styles.r}`}>
        <div className={styles.rInner}>
          {items.map(a => (
            <a
              href={a.link}
              className={`${styles.r1} ${a.id === id ? "hoveredA" : ""}`}
              key={a.id}
              style={{"--dotColor": a.dotColor}}
              // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'SetStateAction<null>'.
              onMouseEnter={() => setId(a.id)}
              onMouseLeave={() => setId(null)}
            >
              {a.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const CovidReadyHeader = ({isMobile}: any) => {
  const [h, setH] = useState(1000);

  useEffect(() => {
    const layout = document.getElementById("layout");
    // @ts-expect-error TS2531: Object is possibly 'null'.
    setH(layout.offsetHeight);
  }, []);

  return (
    <div className={styles.outerWrap}>
      {isMobile ? (
        <Inner />
      ) : (
        <Controller>
          <Scene
            // reverse={false}
            triggerHook={0}
            offset={1}
            triggerElement="#layout"
            duration={h}
            // duration={pageLoaded ? 800 : "100%"}
            indicators={dev}
            classToggle="stick"
            // pin
          >
            <div>
              <Inner />
            </div>
          </Scene>
        </Controller>
      )}
    </div>
  );
};

export default React.memo(CovidReadyHeader);
